module.exports = __webpack_public_path__ + "img/ibragimova.69987540.jpg";